import Modal from "../ui/Modal";
import "./UpgradeModal.css";
import { submitPostRoute } from "../../api/Client";

const FEATURES = [
    "Unlimited course trees",
    "Unlimited problems, instantly graded",
    "No daily limits",
];

interface UpgradeModalProps {
    open: boolean;
    onClose: () => void;
    /** Short, specific line explaining why this popped up right now — e.g.
     *  "You've used today's free trees." Omit for the generic manual-upsell
     *  case (the sidebar panel's own Upgrade button). */
    reason?: string;
}

/**
 * The paywall — same gradient card treatment as the sidebar's UpgradePanel,
 * just full-screen-modal sized, with the price and what's included spelled
 * out. The CTA is the same POST-to-checkout navigation ProfileButton and
 * UpgradePanel both use (see submitPostRoute in Client.ts).
 */
export default function UpgradeModal({ open, onClose, reason }: UpgradeModalProps) {
    return (
        <Modal open={open} onClose={onClose} title="Eolass Plus" panelClassName="upgrade-modal">
            {reason && <p className="upgrade-modal__reason">{reason}</p>}

            <div className="upgrade-modal__price">
                <span className="upgrade-modal__price-amount">$10</span>
                <span className="upgrade-modal__price-period">/ month</span>
            </div>

            <ul className="upgrade-modal__features">
                {FEATURES.map((feature) => (
                    <li key={feature}>
                        <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                            <path
                                d="M5 13 L10 18 L19 7"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                        {feature}
                    </li>
                ))}
            </ul>

            <button className="upgrade-modal__button" type="button" onClick={() => submitPostRoute("/checkout")}>
                Upgrade
            </button>
        </Modal>
    );
}
